function ContributionRateChange () {
  this.init = function () {
    return session.pension.secondPillarContributionRate
  }

  this.done = function () {
    $('#contribution-rate-change-application').on('submit', submit)
    $('#contribution-rate-change-application').on('change', hideErrors)
  }

  function submit(event) {
    event.preventDefault()

    const form = event.target
    const contributionRate = form['chosen-contribution-rate'].value

    if (isDuplicateApplication(contributionRate)) {
      showErrors()
      return
    }

    sessionStorage.setItem('contributionRateApplication', JSON.stringify({contributionRate}) )
    location.href = '#contribution-rate-change-preview'
  }

  function hideErrors() {
    $('#error-messages').addClass('d-none')
  }

  function showErrors() {
    $('#error-messages').removeClass('d-none')
  }

  function isDuplicateApplication(rate) {
    const contributionRate = session.pension.secondPillarContributionRate
    if (contributionRate.nextRates.length === 0) {
      return contributionRate.current.toString() === rate
    }

    const latestRate = contributionRate.nextRates[contributionRate.nextRates.length - 1]
    return latestRate.rate.toString() === rate
  }
}